// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardStatusDto
 */
export interface ICardStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ICardStatusDto
     */
    status?: ICardStatusDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusDto
     */
    lock_reason?: ICardStatusDtoLockReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICardStatusDto
     */
    employee_unlock_forbidden?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ICardStatusDto
     * @deprecated
     */
    locked_purse_ids?: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum ICardStatusDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
* @export
* @enum {string}
*/
export enum ICardStatusDtoLockReasonEnum {
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DOCUMENTATION_REQUIRED = 'DOCUMENTATION_REQUIRED',
    FRAUD_DETECTED = 'FRAUD_DETECTED',
    CARDHOLDERS_REQUEST = 'CARDHOLDERS_REQUEST'
}


/**
 * Check if a given object implements the ICardStatusDto interface.
 */
export function instanceOfICardStatusDto(value: object): value is ICardStatusDto {
    return true;
}

export function ICardStatusDtoFromJSON(json: any): ICardStatusDto {
    return ICardStatusDtoFromJSONTyped(json, false);
}

export function ICardStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'lock_reason': json['lock_reason'] == null ? undefined : json['lock_reason'],
        'employee_unlock_forbidden': json['employee_unlock_forbidden'] == null ? undefined : json['employee_unlock_forbidden'],
        'locked_purse_ids': json['locked_purse_ids'] == null ? undefined : json['locked_purse_ids'],
    };
}

export function ICardStatusDtoToJSON(json: any): ICardStatusDto {
    return ICardStatusDtoToJSONTyped(json, false);
}

export function ICardStatusDtoToJSONTyped(value?: ICardStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'lock_reason': value['lock_reason'],
        'employee_unlock_forbidden': value['employee_unlock_forbidden'],
        'locked_purse_ids': value['locked_purse_ids'],
    };
}

